import React, { useState } from 'react';
import { Formik } from 'formik'
import { useHistory } from 'react-router-dom'
import { Form, Row, Col } from 'react-bootstrap'

import api from '../../services/api'
import AlertCustom from '../alertCustom/index.js'
import BtnLoader from '../buttons/loader/index.js'
import * as schema from '../schemaValidation/index.js'
import errorHandlerShow from '../errorHandlerShow/index.js'
import ControlWithValidation from '../fields/controlWithValidation/index.js'

import './styles.css'

const UserResetPassword = ({props}) => {
    const query = new URLSearchParams(window.location.search);
    const history = useHistory();

    const [loading, setLoading] = useState(false)
    const [showAlert, setShowAlert] = useState(false);
    const [alert, setAlert] = useState({header: '', message: '', type: '', options_btn: []});
    const [email, setEmail] = useState(query.get('email'))
    const [token, setToken] = useState(query.get('token'))



    const CheckIfEmailValid = (email) => {
        let response = true

        const domain = email.split("@")[1]
        const domainAllowed = ["avon.com", "thebodyshop.com", "aesop.com", "thebodyshop.com.br", "aesop.com.br"]

        if (!(domainAllowed.includes(domain))) {
            setAlert({
                header: 'Apenas colaboradores Avon, The Body Shop e Aesop são permitidos.', 
                message: 'Apenas os domínios @avon.com, @thebodyshop.com, @aesop.com, @thebodyshop.com.br e @aesop.com.br são permitidos. \
                Obs.: Se você é colaborador Natura, por gentileza, faça o login com seu e-mail corporativo e senha de rede na página de login do portal.',
                type: 'danger',
                options_btn: []
            })
            setShowAlert(true)
            response = false
        }

        return response
    }

    /**
     * save fields of the forms to data
     */
    const onSubmitUpdateResetPassword = (forms) => {
        setLoading(true)

        const data = {
            ...forms,
            token: token
        }

        if (CheckIfEmailValid(data.email)) {
            // call POST request to save user
            api.put('accounts/password_reset', {
                'data': data
            })
            .then(response => {
                setAlert({
                    header: 'Senha redefinida com sucesso.', 
                    message: response.data.message,
                    type: 'success',
                    options_btn: []
                })

                // show alert to users
                setShowAlert(true)
                setLoading(false)

                // redirect users to /cadastro-arq-manual page after 10 seconds
                setTimeout(() => {history.push('/login')}, 10000)
            })
            .catch(error => {
                errorHandlerShow(error, setToken, setAlert, setShowAlert)
                setLoading(false)
            })
        }else {
            setLoading(false)
        }
    }

    const onSubmitCreateResetPassword = ({ email }) => {
        setLoading(true)

        if (CheckIfEmailValid(email)) {
            // call POST request to save user
            api.post('accounts/users', {
                'email': email,
                'type': 'reset_password'
            })
            .then(response => {
                setAlert({
                    header: 'Solicitação de mudança de senha realizada com sucesso.', 
                    message: response.data.message,
                    type: 'success',
                    options_btn: []
                })

                // show alert to users
                setShowAlert(true)
                setLoading(false)

                // redirect users to /cadastro-arq-manual page after 10 seconds
                setTimeout(() => {history.push('/login')}, 10000)
            })
            .catch(error => {
                errorHandlerShow(error, setToken, setAlert, setShowAlert)
                setLoading(false)
            })
        }else {
            setLoading(false)
        }
    }

    return (
        <div className="user-register-container">
            {/* ALERT CUSTOM */}
            <AlertCustom showAlert={showAlert} setShowAlert={setShowAlert} alert={alert} />

            {email && token ?
                <ResetPassword
                    resetPasswordSchema={schema.ResetPasswordSchema}
                    onSubmit={onSubmitUpdateResetPassword}
                    loading={loading}
                    email_user={email}
                />
            :
                <div>
                    <EmailRegistration
                        userSchema={schema.CreateUserSchema}
                        onSubmit={onSubmitCreateResetPassword}
                        loading={loading}
                    />

                </div>
            }
        </div>
    );
}


/**
 * FORMS
 * define o formulario de requisção
 */
 const EmailRegistration = ({ userSchema, onSubmit, loading }) => (
    <Formik
        initialValues={{
            email: "",
        }}
        validationSchema={userSchema}
        onSubmit={(values) => onSubmit(values)}
        validateOnChange={true}
        validateOnBlur={true}
    >
    {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
    }) => (
        <Form noValidate onSubmit={handleSubmit}>

            <Row className="mb-3">

                <ControlWithValidation Col={Col}
                    type="text"
                    label="E-mail corporativo (Somente colaboradores Avon, The Body Shop e Aesop)"
                    name="email"
                    placeholder="Digite seu e-mail corporativo..."
                    value={values.email}
                    error={errors.email}
                    handleChange={handleChange}
                    readOnly={false}
                />
            
            <Col>
            <Form.Label className="user-register-label-hidden">teste</Form.Label>
            <BtnLoader
                    hasOnClick={false}
                    loading={loading}
                    messageNotLoading="Salvar"
                    messageLoading="Salvando"
                    style={"btn-loader-135px"}
                    variant="success"
                />
            </Col>
            </Row>
        </Form>
    )}
    </Formik>
)


/**
 * FORMS
 * define o formulario de requisção
 */
 const ResetPassword = ({ resetPasswordSchema, onSubmit, loading, email_user }) => (
    <Formik
        initialValues={{
            email: email_user,
            first_password: "",
            second_password: ""
        }}
        validationSchema={resetPasswordSchema}
        onSubmit={(values) => onSubmit(values)}
        validateOnChange={true}
        validateOnBlur={true}
        enableReinitialize={true}
    >
    {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
    }) => (
        <Form noValidate onSubmit={handleSubmit}>

            <RowsRequesting
                values={values}
                errors={errors}
                handleChange={handleChange} />

            <div className="mf-register-next mf-register-next-only">
                <BtnLoader
                    hasOnClick={false}
                    loading={loading}
                    messageNotLoading="Salvar"
                    messageLoading="Salvando"
                    style={"btn-loader-135px"}
                    variant="success"
                />
            </div>
        </Form>
    )}
    </Formik>
)


/**
 * ROWS FORM
 * rows to requesting form
 */
 const RowsRequesting = ({values, errors, handleChange, readOnly}) => (
    <div>
        <Row className="mb-3">

            <ControlWithValidation Col={Col}
                type="text"
                label="E-mail corporativo"
                name="email"
                placeholder="Digite seu e-mail corporativo..."
                value={values.email}
                error={errors.email}
                handleChange={handleChange}
                readOnly={true}
                typeColumn="xs"
                valueColumn={5}
            />

            <ControlWithValidation Col={Col}
                type="password"
                label="Senha"
                name="first_password"
                placeholder="Digite sua senha..."
                value={values.first_password}
                error={errors.first_password}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="password"
                label="Repetir senha"
                name="second_password"
                placeholder="Digite novamente sua senha..."
                value={values.second_password}
                error={errors.second_password}
                handleChange={handleChange}
                readOnly={readOnly}
            />

        </Row>

    </div>
)

export default UserResetPassword;
